import { UnityContent } from 'react-unity-webgl';
import { THETA_DATA_API_ENDPOINT, THETA_RESOURCE_ENDPOINT, THETA_RESOURCE_WEBGL_ENDPOINT } from '@profile/src/constants';
export const unityContent = new UnityContent(`${THETA_RESOURCE_WEBGL_ENDPOINT}/Build/ThetanBox.json`, `${THETA_RESOURCE_WEBGL_ENDPOINT}/Build/UnityLoader.js`, {
  streamingAssetsUrl: `${THETA_RESOURCE_WEBGL_ENDPOINT}/Build/StreamingAssets`,
  adjustOnWindowResize: true
});
const ACCESS_TOKEN = 'LS_ACCESS_TOKEN_KEY';
const ACCESS_TOKEN_EXPIRY = 'LS_ACCESS_TOKEN_EXPIRY_KEY';
const THETAN_DATA_ENDPOINT = 'LS_THETAN_DATA_ENDPOINT';
const BOX_TYPE = 'THETAN_OPEN_BOX_TYPE';
const BOX_AMOUNT = 'THETAN_OPEN_BOX_AMOUNT';
const RECOURCE = 'LS_BUNDLE_LOAD_PATH';
export const storeSessionOpenBox = (accessToken, boxType, amount) => {
  const expiry = Date.now() + 30 * 60 * 1000; // expiry after 30 minutes

  localStorage.setItem(ACCESS_TOKEN, accessToken);
  localStorage.setItem(ACCESS_TOKEN_EXPIRY, expiry.toString());
  localStorage.setItem(BOX_TYPE, boxType.toString());
  localStorage.setItem(BOX_AMOUNT, amount.toString());
  localStorage.setItem(THETAN_DATA_ENDPOINT, THETA_DATA_API_ENDPOINT);
  localStorage.setItem(RECOURCE, THETA_RESOURCE_ENDPOINT);
};
export const clearSessionOpenBox = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(ACCESS_TOKEN_EXPIRY);
  localStorage.removeItem(BOX_TYPE);
  localStorage.removeItem(BOX_AMOUNT);
  localStorage.removeItem(THETAN_DATA_ENDPOINT);
  localStorage.removeItem(RECOURCE);
};